import React from "react";
import { useCart } from "../context/CartContext";
import { useCatalog } from "../context/CatalogContext";

// "GLP-3R & GLP-2T" / "A, B & C" — names of the products in the live sale.
export const useSaleProductNames = () => {
  const { activeSeasonal } = useCart();
  const { products } = useCatalog();
  const names = (activeSeasonal?.product_ids || [])
    .map((s) => products.find((p) => p.slug === s)?.name || s);
  if (names.length <= 1) return names[0] || "";
  return `${names.slice(0, -1).join(", ")} & ${names[names.length - 1]}`;
};

// Price with the seasonal promo applied (original crossed out) when eligible.
export const SalePrice = ({ slug, price, prefix = "", testId, className = "", saleClassName = "" }) => {
  const { activeSeasonal } = useCart();
  const pct = activeSeasonal?.product_ids?.includes(slug) ? activeSeasonal.percent : 0;
  if (!pct) {
    return <span data-testid={testId} className={className}>{prefix}${price.toFixed(2)}</span>;
  }
  return (
    <span data-testid={testId} className={`${className} inline-flex items-baseline gap-2`}>
      <span data-testid={testId && `${testId}-original`} className="line-through text-[#9a7a80] font-normal text-[0.7em]">
        ${price.toFixed(2)}
      </span>
      <span data-testid={testId && `${testId}-sale`} className={`text-[#8B2252] ${saleClassName}`}>
        {prefix}${(price * (1 - pct / 100)).toFixed(2)}
      </span>
    </span>
  );
};

export const SaleBadge = ({ slug, className = "" }) => {
  const { activeSeasonal } = useCart();
  if (!activeSeasonal?.product_ids?.includes(slug)) return null;
  return (
    <span
      data-testid={`sale-badge-${slug}`}
      className={`inline-flex items-center rounded-full bg-[#8B2252] text-white text-[10px] font-semibold tracking-[0.14em] uppercase px-2.5 py-1 ${className}`}
    >
      {activeSeasonal.percent}% off · {activeSeasonal.name}
    </span>
  );
};

export default SalePrice;
